export enum EnumTipoParamAnexo {
  Facturacion = 1,
  Contrato,
  Switching,
  Lead
}
